import React from 'react';

import { Box, Stack, Typography } from '@mui/material';

interface ReviewSectionHeadingProps {
  step: number;
  title: string;
  description: string;
}

export default function ReviewSectionHeading({ step, title, description }: ReviewSectionHeadingProps) {
  return (
    <Stack direction="row" gap={1.5} alignItems="flex-start">
      <Box
        sx={{
          alignItems: 'center',
          bgcolor: 'primary.main',
          borderRadius: '50%',
          color: 'primary.contrastText',
          display: 'flex',
          flex: '0 0 auto',
          fontSize: 14,
          fontWeight: 700,
          height: 28,
          justifyContent: 'center',
          mt: 0.25,
          width: 28,
        }}
      >
        {step}
      </Box>
      <Box>
        <Typography variant="h6">{title}</Typography>
        <Typography variant="body2" color="text.secondary">
          {description}
        </Typography>
      </Box>
    </Stack>
  );
}
